import React from "react";

import { IAPIState } from "shared/types";
import { copy } from "shared/assets";
import { Modal } from "shared/components";
import { Spacer } from "shared/layout";

import {
  CreateInfoBlockItemBaseProps,
  getInfoBlockItemIcon,
} from "shared/utils";

interface CreateInfoBlockItemModalProps extends CreateInfoBlockItemBaseProps {
  createApiStatus?: IAPIState;
  itemReadbleName: string;
  Component: React.FC<any>;
  componentProps: any;
}

export const CreateInfoBlockItemModal: React.FC<CreateInfoBlockItemModalProps> =
  ({ type, handleClose, itemReadbleName, Component, componentProps }) => {
    return (
      <Modal
        handleClose={handleClose}
        title={copy.createInfoBlockItem.title.replace("%s", itemReadbleName)}
        data-testid={`create_${type}_modal`}
        icon={getInfoBlockItemIcon(type)}
        isAnimated={false}
      >
        <Spacer size="xs">
          <Component {...componentProps} />
        </Spacer>
      </Modal>
    );
  };
